/* YSL Gift Finder — step machine + result filtering.
   Mirrors staging: landing -> 6 questions -> curated results.
   Product matching degrades gracefully: category comes from product.type (real data
   today), the finer cues come from `gf-<value>` product tags. A filter that would
   empty the set is dropped instead, so results are never blank. */
(function () {
  'use strict';

  var LAST = 6;

  function init(root) {
    if (root.dataset.gfReady) return;
    root.dataset.gfReady = '1';

    var steps = {};
    root.querySelectorAll('[data-gf-step]').forEach(function (el) {
      steps[el.getAttribute('data-gf-step')] = el;
    });
    var nav = root.querySelector('[data-gf-nav]');
    var navItems = root.querySelectorAll('[data-gf-navitem]');
    var grid = root.querySelector('[data-gf-grid]');
    var empty = root.querySelector('[data-gf-empty]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gf-card]'));
    var limit = parseInt(root.dataset.limit, 10) || 8;
    var budget = parseInt(root.dataset.budget, 10) || 0;

    var answers = {};
    var current = 0;

    function show(n) {
      current = n;
      Object.keys(steps).forEach(function (k) { steps[k].hidden = (k !== String(n)); });
      if (nav) nav.hidden = (n === 0 || n === 7);
      navItems.forEach(function (li) {
        var i = parseInt(li.getAttribute('data-gf-navitem'), 10);
        li.classList.toggle('is-active', i === n);
        li.classList.toggle('is-done', i < n);
        var val = li.querySelector('[data-gf-navval]');
        if (val) val.textContent = (i < n && answers[i]) ? answers[i].label : '';
      });
      var top = root.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: n === 0 ? top : top, behavior: 'smooth' });
    }

    /* Q3 shows only the branch matching the Q2 answer. */
    function branch() {
      var b = answers[2] ? answers[2].value : '';
      var q3 = steps['3'];
      if (!q3) return;
      var shown = 0;
      q3.querySelectorAll('[data-branch]').forEach(function (t) {
        var on = t.getAttribute('data-branch') === b;
        t.hidden = !on;
        if (on) shown++;
        if (!on) {
          var i = t.querySelector('input');
          if (i) i.checked = false;
          t.classList.remove('is-selected');
        }
      });
      var tiles = q3.querySelector('.ysl-gf__tiles');
      if (tiles) tiles.style.setProperty('--gf-cols', Math.min(shown, 4));
      var next = q3.querySelector('[data-gf-next]');
      if (next) next.disabled = true;
      delete answers[3];
    }

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-gf-input]');
      if (!input) return;
      var step = input.closest('[data-gf-step]');
      var n = parseInt(step.getAttribute('data-gf-step'), 10);
      step.querySelectorAll('.ysl-gf__tile').forEach(function (t) {
        t.classList.toggle('is-selected', t.contains(input));
      });
      answers[n] = { value: input.value, label: input.getAttribute('data-label') || '' };
      var next = step.querySelector('[data-gf-next]');
      if (next) next.disabled = false;
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-gf-start]')) { show(1); return; }
      if (e.target.closest('[data-gf-prev]')) { show(Math.max(0, current - 1)); return; }
      if (e.target.closest('[data-gf-restart]')) {
        answers = {};
        root.querySelectorAll('[data-gf-input]').forEach(function (i) { i.checked = false; });
        root.querySelectorAll('.ysl-gf__tile').forEach(function (t) { t.classList.remove('is-selected'); });
        root.querySelectorAll('[data-gf-next]').forEach(function (b) { b.disabled = true; });
        show(0);
        return;
      }
      if (e.target.closest('[data-gf-next]')) {
        if (current === 2) branch();
        if (current === LAST) { results(); show(7); }
        else show(current + 1);
      }
    });

    function tagged(list, value) {
      if (!value) return list;
      var tag = 'gf-' + value.toLowerCase();
      var hit = list.filter(function (c) {
        return (' ' + (c.dataset.tags || '') + ' ').indexOf(' ' + tag + ' ') > -1;
      });
      return hit.length ? hit : list; /* drop a filter rather than return nothing */
    }

    function results() {
      var list = cards.slice();

      var cat = answers[2] ? answers[2].value : '';
      if (cat === 'makeup' || cat === 'fragrance') {
        var byType = list.filter(function (c) { return c.dataset.type === cat; });
        if (byType.length) list = byType;
      }

      list = tagged(list, answers[3] && answers[3].value);
      list = tagged(list, answers[4] && answers[4].value);
      list = tagged(list, answers[5] && answers[5].value);

      var cheap = (answers[6] || {}).value === 'downToEarth';
      if (cheap && budget > 0) {
        var under = list.filter(function (c) { return parseInt(c.dataset.price, 10) <= budget; });
        if (under.length) list = under;
      }
      list.sort(function (a, b) {
        var pa = parseInt(a.dataset.price, 10) || 0;
        var pb = parseInt(b.dataset.price, 10) || 0;
        return cheap ? pa - pb : pb - pa;
      });

      cards.forEach(function (c) { c.hidden = true; });
      list.slice(0, limit).forEach(function (c, i) {
        c.hidden = false;
        c.style.order = i;
        grid.appendChild(c);
      });
      if (empty) empty.hidden = list.length > 0;
    }
  }

  function boot() { document.querySelectorAll('.ysl-gf').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
